/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { msdyn365Commerce, isOboRequest } from '@msdyn365-commerce/core-internal';
import * as React from 'react';
import Chat from './helpers/chat';
import { IMsdyn365CsChatConnectorData } from './interfaces';
import { IMsdyn365CsChatConnectorProps } from './msdyn365-cs-chat-connector.props.autogenerated';

/**
 * Provides options for chat connector view.
 */
export interface IMsdyn365CsChatConnectorViewProps extends IMsdyn365CsChatConnectorProps<IMsdyn365CsChatConnectorData> {
    // Do nothing. Keeps lint happy.
}

/**
 * Msdyn365CsChatConnector component.
 * @augments {React.PureComponent<IMsdyn365CsChatConnectorProps<IMsdyn365CsChatConnectorData>>}
 */
export default class Msdyn365CsChatConnector extends React.PureComponent<IMsdyn365CsChatConnectorProps<IMsdyn365CsChatConnectorData>> {
    constructor(props: IMsdyn365CsChatConnectorProps<IMsdyn365CsChatConnectorData>) {
        super(props);

        if (isOboRequest(this.props.context.request)) {
            return;
        }

        if (msdyn365Commerce.isBrowser && typeof window !== 'undefined') {
            window.addEventListener('lcw:error', (errorEvent: object) => {
                // Handle LiveChat SDK error event
                this.props.telemetry.error('lcw:error', errorEvent);
            });

            window.addEventListener('lcw:ready', () => {
                const chat: Chat = new Chat(this.props);
                chat.run().catch(e => {
                    this.props.telemetry.error(e);
                });
            });
        }
    }

    public componentDidMount(): void {}

    public render(): JSX.Element | null {
        if (isOboRequest(this.props.context.request)) {
            return null;
        }

        return this.props.renderView(this.props);
    }
}
